
import React from 'react';
import Navbar from '@/components/Navbar';
import Hero from '@/components/Hero';
import FeatureOverview from '@/components/FeatureOverview';
import MainFeatures from '@/components/MainFeatures';
import SectionLayout from '@/components/SectionLayout';
import WhoIsAskSpotFor from '@/components/WhoIsAskSpotFor';
import TestimonialVideos from '@/components/TestimonialVideos';
import FAQ from '@/components/FAQ';
import FinalCTA from '@/components/FinalCTA';
import Footer from '@/components/Footer';

const Index = () => {
  // Log when the Index page renders to help with debugging
  React.useEffect(() => {
    console.log('Index page mounted');
    return () => console.log('Index page unmounted');
  }, []);

  return (
    <main className="min-h-screen bg-white">
      <Navbar />
      
      <Hero />
      
      {/* Who Is AskSpot For Section - Solid accent color background */}
      <SectionLayout 
        backgroundColor="bg-[#FEE6D8]" 
        paddingY="py-16 md:py-24"
        className="relative z-10 border-t border-gray-100"
        backgroundPattern="soft-mesh"
        patternOpacity={3}
      >
        <WhoIsAskSpotFor />
      </SectionLayout>
      
      {/* Feature Overview Section - Clean white background */}
      <SectionLayout 
        backgroundColor="bg-white" 
        paddingY="py-16 md:py-24"
        className="relative z-20"
        backgroundPattern="none"
      >
        <FeatureOverview />
      </SectionLayout>
      
      {/* Video Testimonials Section - Light background */}
      <SectionLayout 
        backgroundColor="bg-gray-50" 
        paddingY="py-16 md:py-24"
        className="relative z-10"
        backgroundPattern="soft-mesh"
        patternOpacity={3}
      >
        <TestimonialVideos />
      </SectionLayout>
      
      {/* Main Features Section - Light primary color background */}
      <SectionLayout 
        backgroundColor="bg-[#003a70]/10" 
        paddingY="py-4 md:py-8"
        className="relative z-10"
        backgroundPattern="soft-mesh"
        patternOpacity={3}
      >
        <MainFeatures />
      </SectionLayout>
      
      {/* FAQ Section - White background */}
      <SectionLayout 
        backgroundColor="bg-white" 
        paddingY="py-16 md:py-24"
        className="relative z-10"
        backgroundPattern="none"
      >
        <FAQ />
      </SectionLayout>
      
      {/* Final CTA Section - Accent color background */}
      <SectionLayout 
        backgroundColor="bg-[#FEE6D8]/50" 
        paddingY="py-16 md:py-24"
        className="relative z-10"
        backgroundPattern="soft-mesh"
        patternOpacity={3}
      >
        <FinalCTA />
      </SectionLayout>
      
      {/* Footer */}
      <Footer />
    </main>
  );
};

export default Index;
